export default __webpack_public_path__ + "static/LabelWithIcon-604f961406ebab3c85b4124e5c333fd0.png";